module.exports = __webpack_public_path__ + "static/media/2 1 ordkjedetekst.85a87ad9.mp3";